import apiClient from "./client";

export const getPublicSolutions = async () => {
  const response = await apiClient.get("/solutions");
  return response.data;
};

export const getPublicSolutionByKey = async (solutionKey, language = "en") => {
  const key = String(solutionKey || "").trim();
  if (!key) return null;

  const attempts = [
    () => apiClient.get(`/solutions/${encodeURIComponent(key)}`, { params: { language } }),
    () => apiClient.get("/solutions", { params: { solutionKey: key, language } }),
    () => apiClient.get("/solutions", { params: { key, language } }),
  ];

  for (const run of attempts) {
    try {
      const response = await run();
      const data = response?.data;
      if (!data) continue;
      if (Array.isArray(data)) {
        const hit = data.find((it) => String(it?.solutionKey || "").toLowerCase() === key.toLowerCase());
        if (hit) return hit;
        continue;
      }
      return data;
    } catch {
      // try next endpoint shape
    }
  }

  return null;
};
